// extracted by mini-css-extract-plugin
export default {"password-change":"gLegyRyIfbCM_LAgSv85","form":"L3dS9FuPfkLkCsQFX3T7"};